export default class {
    _id;
    _createdOn;
    _performedOn;
    _note;
    _performType;
    _courier;
    _postIndex;
    _recipient;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value;
    }

    get performedOn() {
        return this._performedOn;
    }

    set performedOn(value) {
        this._performedOn = value;
    }

    get note() {
        return this._note;
    }

    set note(value) {
        this._note = value;
    }

    get performType() {
        return this._performType;
    }

    set performType(value) {
        this._performType = value;
    }

    get recipient() {
        return this._recipient;
    }

    set recipient(value) {
        this._recipient = value;
    }



    get courier() {
        return this._courier;
    }

    set courier(value) {
        this._courier = value;
    }

    get postIndex() {
        return this._postIndex;
    }

    set postIndex(value) {
        this._postIndex = value;
    }
}